import {
  PERMISSIONS,
  ROLES,
  accessFromUser,
  checkAccess,
  type AccessSnapshot,
} from "./permissions";
import { readUserSession } from "services/access";

/** Baixa, cancelamento e edição de títulos (sem ROLE_USER_GER no backend). */
export const FINANCE_WRITE_ACCESS = {
  roles: [ROLES.ROLE_USER_FIN, ROLES.ROLE_ADMIN, ROLES.ROLE_MASTER],
  permissions: [PERMISSIONS.PERMISSION_FINANCEIRO],
};

export function canFinanceWrite(access?: AccessSnapshot | null): boolean {
  const snapshot = access ?? accessFromUser(readUserSession());
  return checkAccess(snapshot, FINANCE_WRITE_ACCESS);
}
